import api from './axiosInstance';

const withConfirmationAliases = (payload) => {
  const confirmationText = payload?.confirmationText?.trim();
  return confirmationText
    ? {
        ...payload,
        confirmationText,
        confirmation: confirmationText,
        confirmText: confirmationText,
      }
    : payload;
};

export const getStrategies = (params = {}) => api.get('/strategy-library', { params });
export const getActiveStrategies = () => getStrategies({ active: true });
export const createStrategy = (payload) => {
  return api.post('/strategy-library', withConfirmationAliases(payload));
};
export const updateStrategy = (id, payload) => api.patch(`/strategy-library/${id}`, payload);
export const deactivateStrategy = (id, payload = {}) => api.patch(`/strategy-library/${id}`, {
  ...payload,
  isActive: false,
});
export const deleteStrategy = (id, payload) => api.delete(`/strategy-library/${id}`, {
  data: withConfirmationAliases(payload),
});

export const normalizeStrategy = (strategy = {}) => {
  const slug = strategy.slug || strategy.key || strategy.type || '';
  return {
    ...strategy,
    id: strategy._id || strategy.id || slug,
    slug,
    key: strategy.key || slug,
    name: strategy.name || strategy.title || strategy.label || slug,
    title: strategy.title || strategy.name || strategy.label || slug,
    icon: strategy.icon || '🎯',
    category: strategy.category || 'bullish',
    chartinkUrl: strategy.chartinkUrl || strategy.url || '',
    isActive: strategy.isActive !== false,
  };
};

export const extractStrategyRows = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.strategies)) return data.strategies;
  if (Array.isArray(data?.strategyMeta)) return data.strategyMeta;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

export const normalizeStrategies = (rows = []) => rows.map(normalizeStrategy);